<template>
    <div>
        <a-card size="small" title="消息统计">
        </a-card>
        <channelSelecter  :isDisabled="false" @onChannelCodeChange="handleChannelChange"></channelSelecter>
        <a-card size="small">

            <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
                <a-form-item label="业务分类">
                    <messageTypeSelecter :showAll="true" :channelcode="searchP.channelcode" @onmessagestypecodeChange="handleMessagestypecodeChange"></messageTypeSelecter>
                </a-form-item>
                <a-form-item>
                        <timeSelecter v-model="searchP.selectedTimeRange" style="margin-left:20px;"></timeSelecter>
                </a-form-item>
                <a-form-item>
                        <a-button type="primary"  @click="handleSubmit">查询</a-button>
                </a-form-item>
            </a-form>

            <a-row :gutter="16" style="margin-top:20px;">
                <a-col :span="12">
                    <msgpie ref="msgpieID" :boxid="'pie_id_type'"></msgpie>
                </a-col>
                <a-col :span="12">
                    <msgpie ref="msgpieID2" :boxid="'pie_id_status'"></msgpie>
                </a-col>
            </a-row>
           
        </a-card>
    </div>
</template>
<script>
import msgpie from './msgpie'
import timeSelecter from '../comp/timeselecter'
import messageTypeSelecter from '../../components/messageTypeSelecter'
import channelSelecter from '../../components/channelSelecter'
export default {
    data() {
        return {
            form: this.$form.createForm(this),
            channelcode:'',
            searchP:{
                channelcode:'',
                messagestypecode:'',
                selectedTimeRange:'',
            },
        };
    },
    methods: {
        handleMessagestypecodeChange(msg){
            this.searchP.messagestypecode = msg.messagestypecode;
            this.handleSubmit();
        },
        handleChannelChange(item){
            this.searchP.channelcode = item.value;
        },
        handleSubmit(){
            console.log(this.searchP.selectedTimeRange)
            this.$refs.msgpieID.loadData(this.searchP)
            this.$refs.msgpieID2.loadData(this.searchP)
        },

    },
    components:{
        channelSelecter,
        messageTypeSelecter,
        msgpie,
        timeSelecter
    },
    mounted(){

    }
};
</script>
<style scoped>

</style>
